<template>
    <div>
        <el-dialog title="新建客户" :visible.sync="newCustomerVisible" width="1000px" top="10vh"
            v-loading="newCustomerLoading" @close="$emit('closedialog')">
            <div class="newCustomerTtiel">公司信息字段：</div>
            <el-form label-width="100px" size="small" label-position="left">
                <el-row :gutter="16">
                    <el-col :span="8">
                        <el-form-item label="公司名称" required>
                            <el-input v-model="newCustomer.form.name" @blur="checkRepeat" />
                        </el-form-item>
                    </el-col>
                    <el-col :span="8" v-if="dialogType==0">
                        <el-form-item label="公司分组" :required="this.isRequired.group">
                            <el-select v-model="newCustomer.form.publicGroupKey">
                                <el-option v-for="item in groupOption" :key="item.key" :label="item.name" :value="item.key" />
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8" v-else>
                        <el-form-item label="公司分组" :required="this.isRequired.group">
                            <el-select v-model="newCustomer.form.privateGroupKey">
                                <el-option v-for="item in groupOption" :key="item.key" :label="item.name" :value="item.key" />
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="公司来源" :required="this.isRequired.source">
                            <el-select v-model="newCustomer.form.customerSourceKey">
                                <el-option v-for="item in customerSourceOption" :key="item.key" :label="item.name"
                                    :value="item.key" />
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="规模" :required="this.isRequired.scale">
                            <el-select v-model="newCustomer.form.companyScaleValue">
                                <el-option v-for="item of companyScaleValueOptions" :key="item.value" :label="item.name"
                                    :value="item.name" />
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="国家地区" :required="this.isRequired.country">
                            <el-select v-model="newCustomer.form.country" style="width:100%;" filterable>
                                <el-option v-for="item of countryOptions" :key="item" :value="item" />
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="公司状态" :required="this.isRequired.statu">
                            <el-select v-model="newCustomer.form.statuKey" placeholder="公司状态">
                                <el-option v-for="item in statusOption" :key="item.key" :label="item.name"
                                    :value="item.key" />
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="公司简称" :required="this.isRequired.nickName">
                            <el-input v-model="newCustomer.form.nickName" />
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="主营产品" :required="this.isRequired.mainIndustryValue">
                            <el-input v-model="newCustomer.form.mainIndustryValue" />
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="公司类型" :required="this.isRequired.mainBusinessTypeValue">
                            <el-input v-model="newCustomer.form.mainBusinessTypeValue" />
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="公司地址" :required="this.isRequired.address">
                            <el-input v-model="newCustomer.form.address" />
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="网址" :required="this.isRequired.webSite">
                            <el-input v-model="newCustomer.form.webSite" />
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="传真" :required="this.isRequired.fax">
                            <el-input v-model="newCustomer.form.fax" />
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="电话" :required="this.isRequired.call">
                            <el-input v-model="newCustomer.form.call"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="公司备注" :required="this.isRequired.note">
                            <el-input v-model="newCustomer.form.remarks" />
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="客户星级" :required="this.isRequired.star">
                            <el-rate v-model="newCustomer.form.star" />
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
            <div class="newCustomerTtiel">联系人信息字段：</div>
            <el-form label-width="100px" size="small" label-position="left">
                <el-row :gutter="16">
                    <el-col :span="8">
                        <el-form-item label="主要联系人">
                            <el-radio-group v-model="newCustomer.presetFormContact.isMain">
                                <el-radio :label="true">是</el-radio>
                                <el-radio :label="false">否</el-radio>
                            </el-radio-group>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="联系人名称" required>
                            <el-input v-model="newCustomer.presetFormContact.nickname" placeholder="联系人名称"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="邮箱" required>
                            <el-input v-model="newCustomer.presetFormContact.email" placeholder="邮箱"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="职位">
                            <el-input v-model="newCustomer.presetFormContact.position" placeholder="职位"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="联系电话">
                            <el-input v-model="newCustomer.presetFormContact.call" placeholder="联系电话"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="性别">
                            <el-input v-model="newCustomer.presetFormContact.gender" placeholder="性别"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="备注">
                            <el-input v-model="newCustomer.presetFormContact.note" placeholder="备注"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
            <!-- 添加自定义字段 -->
            <ShowSaveField ref="saveField" :type="0" />
            <span slot="footer" class="dialog-footer">
                <el-button size="small" @click="handleNewConfirmClick(0)">加入公海客户</el-button>
                <el-button size="small" type="primary" @click="handleNewConfirmClick(1)">加入我的客户</el-button>
            </span>
        </el-dialog>

        <el-dialog title="客户查重" :visible.sync="repeatVisible" width="500px">
            <p style="color: var(--themeColor);">*tip 该公司名称可能与以下公司重复</p>
            <el-table :data="repeatCompanyList" style="width: 100%">
                <el-table-column prop="companyName" label="公司名称"></el-table-column>
                <el-table-column prop="belongTo" label="所属成员"></el-table-column>
            </el-table>
            <span slot="footer" class="dialog-footer">
                <el-button size="small" @click="repeatVisible = false;">关 闭</el-button>
            </span>
        </el-dialog>


    </div>
</template>

<script>
import ShowSaveField from "@/components/ShowSaveField.vue";
export default {
    props: ['dialogType','newCustomerVisible','newCustomer','groupOption','inquiryKey'],
    components: { ShowSaveField },
    data() {
        return {
            newCustomerLoading: false,
            customerSourceOption: [],
            companyScaleValueOptions: [
                {
                    value: 1,
                    name: "少于59人",
                    en_name: "Less than 59 employees",
                },
                {
                    value: 2,
                    name: "60-149人",
                    en_name: "60-149 employees",
                },
                {
                    value: 3,
                    name: "150-499人",
                    en_name: "150-499 employees",
                },
                {
                    value: 4,
                    name: "500-999人",
                    en_name: "500-999 employees",
                },
                {
                    value: 5,
                    name: "1000-4999人",
                    en_name: "1000-4999 employees",
                },
                {
                    value: 6,
                    name: "5000人以上",
                    en_name: "More than 5000 employees",
                },
            ],
            countryOptions: window.ContryList,
            statusOption: [],

            //公司系统配置
            comConfig: {},
            isRequired: {},

            //重复公司名列表
            repeatCompanyList: [],
            repeatVisible: false,
            
        };
    },
    methods: {
        //客户查重(检测公司名称是否重复提示)
        checkRepeat(){
            let companyName = this.newCustomer.form.name;
            if(!companyName){return;}
            this.$axios.get(`${this.$customerUrl}/Company/CustomerCheck?companyName=${companyName}`).then((res) => {
                const { isSuccess, data } = res;
                if (isSuccess && data.length) {
                    this.repeatVisible = true;
                    this.repeatCompanyList = data;
                }
            });
        },

        validateNotEmpty(str,label,isRequired){
            if(isRequired && str.trim()===''){
                this.$message.warning(`${label}不得为空`)
                throw new Error()
            }
        },
        async handleNewConfirmClick(type){
            try {
                const arr = [
                    [this.newCustomer.form.name,'公司名称',true],
                    [this.dialogType==0?this.newCustomer.form.publicGroupKey:this.newCustomer.form.privateGroupKey,'公司分组',this.isRequired.group],
                    [this.newCustomer.form.customerSourceKey,'公司来源',this.isRequired.source],
                    [this.newCustomer.form.companyScaleValue,'规模',this.isRequired.scale],
                    [this.newCustomer.form.country,'国家地区',this.isRequired.country],
                    [this.newCustomer.form.statuKey,'公司状态',this.isRequired.statu],
                    [this.newCustomer.form.nickName,'公司简称',this.isRequired.nickName],
                    [this.newCustomer.form.mainIndustryValue,'主营产品',this.isRequired.mainIndustryValue],
                    [this.newCustomer.form.mainBusinessTypeValue,'公司类型',this.isRequired.mainBusinessTypeValue],
                    [this.newCustomer.form.address,'公司地址',this.isRequired.address],
                    [this.newCustomer.form.webSite,'网址',this.isRequired.webSite],
                    [this.newCustomer.form.fax,'传真',this.isRequired.fax],
                    [this.newCustomer.form.call,'电话',this.isRequired.call],
                    [this.newCustomer.form.remarks,'公司备注',this.isRequired.note],
                    [this.newCustomer.form.star,'星级',this.isRequired.star],
                    [this.newCustomer.presetFormContact.nickname,'联系人名称',true],
                    [this.newCustomer.presetFormContact.email,'邮箱',true]
                ]
                for(const [str,label,isRequired] of arr){
                    this.validateNotEmpty(str,label,isRequired);
                }
            } catch {
                return
            }
            try {
                this.newCustomerLoading = true;
                await  this.$axios({
                    method:'POST',
                    url:this.$customerUrl+'/Company/Save',
                    data:{
                        ...this.newCustomer.form,
                        contacters:[this.newCustomer.presetFormContact],
                        type: type, //0加入公海客户 1加入我的客户
                        inquiryKey: this.inquiryKey || '', //询盘星加入客户时，询盘星ID
                    }
                }).then(res => {
                    if(res.data){
                        this.$refs.saveField.onSave(res.data);
                    }
                })
            } catch {
                null
            } finally {
                this.newCustomerLoading = false;
                this.$emit('newCustomerComplete');
            }
        },

        async getSourceOption(){
            try {
                const res=await this.$axios({
                    method: "GET",
                    url: this.$customerUrl + "/v1/Config/Source",
                });
                this.customerSourceOption = res.data || [];
                this.newCustomer.form.customerSourceKey = res.data.filter(ele=>ele.isDefault)[0]?.key??"";
            } catch  {
                this.customerSourceOption = [];
            }
        },
        async getStatusOption(){
            try {
                const res=await this.$axios({
                    method: "GET",
                    url: this.$customerUrl + "/v1/Config/Statu",
                });
                this.statusOption = res.data || [];
                this.newCustomer.form.statuKey = res.data.filter(ele=>ele.isDefault)[0]?.key??"";
            } catch  {
                this.statusOption = [];
            }
        },
    },
    mounted() {
        //获取公司系统配置
        this.comConfig = localStorage.comConfig ? JSON.parse(localStorage.comConfig) : {};
        this.comConfig.customerFieldSettings.forEach(item =>{
            this.isRequired[item.column] = item.required;
        })

        this.getSourceOption(); //获取来源列表数据
        this.getStatusOption(); //获取状态列表数据
    },
};
</script>

<style lang='scss' scoped>
.newCustomerTtiel {
    height: 20px;
    line-height: 20px;
    font-size: 16px;
    font-weight: bold;
    color: #3A3A3A;
    margin-bottom: 10px;
    border-left: 3px solid var(--themeColor);
    padding-left: 5px;
}
</style>